import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { GroupDto, SchoolDto, UpdateSchoolDto, UserDto } from '@oracychampions/api-interfaces';

@Injectable({
  providedIn: 'root',
})
export class SchoolsService {
  private http = inject(HttpClient);

  refresh$ = new BehaviorSubject(null);

  reloadSchools() {
    this.refresh$.next(null);
  }

  getSchools(): Observable<SchoolDto[]> {
    return this.refresh$.pipe(switchMap(() => this.http.get<SchoolDto[]>(`${environment.API}/schools`)));
  }

  getSchoolGroups(schoolId: string): Observable<GroupDto[]> {
    return this.refresh$.pipe(
      switchMap(() => this.http.get<GroupDto[]>(`${environment.API}/schools/${schoolId}/groups`)),
    );
  }

  getSchoolUsers(schoolId: string): Observable<UserDto[]> {
    return this.refresh$.pipe(
      switchMap(() => this.http.get<UserDto[]>(`${environment.API}/schools/${schoolId}/users`)),
    );
  }

  createSchool(school: UpdateSchoolDto): Observable<SchoolDto[]> {
    return this.http.post<SchoolDto[]>(`${environment.API}/schools`, school);
  }

  updateSchool(id: string, school: UpdateSchoolDto): Observable<SchoolDto[]> {
    return this.http.patch<SchoolDto[]>(`${environment.API}/schools/${id}`, school);
  }

  deleteSchool(id: string): Observable<any> {
    return this.http.delete<SchoolDto[]>(`${environment.API}/schools/${id}`);
  }
}
